// HTTP client for the untouched PHP backend (.ai/backend-api.md): form-urlencoded in, JSON out
// (served as text/html), cookies included. Any failure (network, non-2xx, non-JSON) becomes
// {result: 'error'} so callers never throw (ACCQ-016 fixed).
import { env } from '../env';

export interface ApiResponse {
  result: string;
  response?: unknown;
  msg?: string;
}

const FORM = 'application/x-www-form-urlencoded; charset=utf-8';

function encode(params: Record<string, string | number | null | undefined>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v !== null && v !== undefined) p.append(k, String(v));
  return p.toString();
}

async function parse(res: Response): Promise<ApiResponse> {
  if (!res.ok) return { result: 'error' };
  try {
    const json = JSON.parse(await res.text()) as unknown;
    return json && typeof json === 'object' && 'result' in json ? (json as ApiResponse) : { result: 'error' };
  } catch {
    return { result: 'error' };
  }
}

export async function post(path: string, params: Record<string, string | number | null | undefined>): Promise<ApiResponse> {
  try {
    const res = await fetch(env.fullAddr + path, { method: 'POST', credentials: 'include', headers: { 'Content-Type': FORM }, body: encode(params) });
    return await parse(res);
  } catch {
    return { result: 'error' };
  }
}

export async function get(path: string, params: Record<string, string | number | null | undefined> = {}, headers: Record<string, string> = {}): Promise<ApiResponse> {
  try {
    const q = encode(params);
    const res = await fetch(env.fullAddr + path + (q ? `?${q}` : ''), { method: 'GET', credentials: 'include', headers });
    return await parse(res);
  } catch {
    return { result: 'error' };
  }
}
